
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Color from "../../utils/colorHelper";
import { draggable } from "../../utils/draggable";

@Component({})
export default class ColorPanel extends Vue {
  @Prop({ required: true }) private color!: Color;

  cursorLeft = 0;
  cursorTop = 0;
  background = "hsl(0, 100%, 50%)";

  get colorValue() {
    const hue = this.color.get("hue");
    const value = this.color.get("value");
    return { hue, value };
  }

  @Watch("colorValue")
  changeColor() {
    this.update();
  }

  update() {
    const saturation = this.color.get("saturation");
    const value = this.color.get("value");
    const { clientWidth: width, clientHeight: height } = this.$el;
    this.cursorLeft = (saturation * width) / 100;
    this.cursorTop = ((100 - value) * height) / 100;
    this.background = "hsl(" + this.color.get("hue") + ", 100%, 50%)";
  }

  handleDrag(event: MouseEvent) {
    const el = this.$el;
    const rect = el.getBoundingClientRect();
    let left = event.clientX - rect.left;
    let top = event.clientY - rect.top;
    left = Math.max(0, left);
    left = Math.min(left, rect.width);

    top = Math.max(0, top);
    top = Math.min(top, rect.height);

    this.cursorLeft = left;
    this.cursorTop = top;
    this.color.set({
      saturation: (left / rect.width) * 100,
      value: 100 - (top / rect.height) * 100
    });
  }

  mounted() {
    const dragConfig = {
      drag: (event: MouseEvent) => {
        this.handleDrag(event);
      },
      end: (event: MouseEvent) => {
        this.handleDrag(event);
      }
    };
    draggable(this.$el as HTMLElement, dragConfig);
    this.update();
  }
}
